<template>
  <el-form label-position="top" disabled>
    <template slot="sub">
      <p>{{ $t('ec-line015.content.subscriptionNote') }}</p>
    </template>
    <el-form-item class="mt-5">
      <el-radio
        class="radio-dot"
        :label="Constants.DELIVERY_PATTERN_CHANGE.MONTHLY_DATE_SPECIFICATION"
        :value="data.subscription_division_id"
        >{{ $t('ec-line015.content.monthlyDateSpecification') }}</el-radio
      >

      <el-row :gutter="12" class="mt-3" type="flex">
        <el-col :span="6" :lg="5">
          <disabled-input :value="data.param1_1" />
        </el-col>
        <el-col :span="6" :lg="7">{{ $t('ec-line015.content.everyMonth') }}</el-col>
        <el-col :span="6" :lg="5">
          <disabled-input :value="data.param1_2" />
        </el-col>
        <el-col :span="6" :lg="5">{{ $t('ec-line015.content.deliverToTheDay') }}</el-col>
      </el-row>
      <p class="mt-1">{{ $t('ec-line015.content.monthlyNote') }}</p>
    </el-form-item>

    <el-form-item>
      <el-radio
        class="radio-dot"
        :label="Constants.DELIVERY_PATTERN_CHANGE.INTERVAL_DESIGNATION"
        :value="data.subscription_division_id"
        >{{ $t('ec-line015.content.intervalDesignation') }}</el-radio
      >

      <el-row :gutter="12" class="mt-3" type="flex">
        <el-col :span="7">
          <disabled-input :value="data.param2_1" />
        </el-col>
        <el-col :span="17">
          {{ $t('ec-line015.content.everyMonth') }}
        </el-col>
      </el-row>

      <el-row :gutter="12" class="mt-3" type="flex">
        <el-col :span="7">
          <disabled-input :value="$t('common.weekNo', { week: data.param2_2 })" />
        </el-col>
        <el-col :span="7">
          <disabled-input :value="getLabelDayOfWeeks(data.param2_3)" />
        </el-col>
        <el-col :span="10">
          {{ $t('ec-line015.content.deliverTo') }}
        </el-col>
      </el-row>
    </el-form-item>

    <el-form-item>
      <el-radio
        class="radio-dot"
        :label="Constants.DELIVERY_PATTERN_CHANGE.SPECIFY_DELIVERY_DATE_INTERVAL"
        :value="data.subscription_division_id"
        >{{ $t('ec-line015.content.specifyDeliveryDateInterval') }}</el-radio
      >

      <el-row :gutter="12" class="mt-3" type="flex">
        <el-col :span="7">
          <disabled-input :value="data.param3_1" />
        </el-col>
        <el-col :span="17">
          {{ $t('ec-line015.content.deliverDaily') }}
        </el-col>
      </el-row>
    </el-form-item>

    <el-form-item :label="$t('ec-line028.content.nextDeliveryDate')">
      <disabled-input :value="Utils.date.formatDateStringJP(data.next_delivery_date)" />
      <div class="text-right">
        <el-checkbox class="ml-auto mt-2" :value="data.autoCalcLastDeliveryDate">{{
          $t('ec-line015.content.autoCalcLastDeliveryDate')
        }}</el-checkbox>
      </div>
    </el-form-item>

    <el-form-item :label="$t('ec-line028.content.nextDeliveryDate2')">
      <disabled-input :value="Utils.date.formatDateStringJP(data.next_next_delivery_date)" />
      <div class="text-right">
        <el-checkbox class="ml-auto mt-2" :value="data.autoCalcLastDeliveryDate2">{{
          $t('ec-line015.content.autoCalcLastDeliveryDate2')
        }}</el-checkbox>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
import DisabledInput from '@/components/DisabledInput.vue'

export default {
  components: { DisabledInput },
  props: {
    data: { type: Object, DisabledInputdefault: () => {} },
  },
  data() {
    return {
      dayOfWeeks: Object.entries(this.Constants.DAY_OF_WEEK).map(([key, val]) => ({
        value: val,
        label: this.$t(`common.dayOfWeek.${this.$_.camelCase(key)}`),
      })),
    }
  },

  methods: {
    getLabelDayOfWeeks(value) {
      return this.dayOfWeeks.find((i) => i.value === value).label
    },
  },
}
</script>

<style></style>
